let HOST = '/api';
//let HOST = 'http://medivh_plus.test.knowbox.cn';
const version = "1.2.0";
const source = "medivhplus";
const API={
    GET_USER_INFO:`${HOST}/common/user/info?source=${source}&version=${version}`,
    GET_MENU_INFO:`${HOST}/quantity/quantity/tab-info?source=${source}&version=${version}`,
    GET_EDITION_LIST:`${HOST}/quantity/quantity/edition-list?source=${source}&version=${version}`,
    GET_CHANGE_TREND:`${HOST}/quantity/quantity/change-trend?source=${source}&version=${version}`,
    GET_QUESTION_TREND:`${HOST}/quantity/quantity/question-trend?source=${source}&version=${version}`,
    GET_DETAIL:`${HOST}/quantity/quantity/detail?source=${source}&version=${version}`,
    GET_LEARN_DATA:`${HOST}/quantity/quantity/edition?source=${source}&version=${version}`,
    GET_LEARN_INFO_DATA:`${HOST}/quantity/quantity/grade-info?source=${source}&version=${version}`,
    GET_OVER_VIEW:`${HOST}/quantity/quantity/over-view?source=${source}&version=${version}`,
    EXPORT_DETAIL:`${HOST}/quantity/quantity/detail-statistics?source=${source}&version=${version}`,
    GET_EDITION_RATE:`${HOST}/quantity/cover-rate/edition?source=${source}&version=${version}`,
    GET_EDITION_DETAIL:`${HOST}/quantity/cover-rate/edition-detail?source=${source}&version=${version}`,
    GET_KNOWLEDGE_RATE:`${HOST}/quantity/cover-rate/knowledge?source=${source}&version=${version}`,
    GET_KNOWLEDGE_DETAIL:`${HOST}/quantity/cover-rate/knowledge-detail?source=${source}&version=${version}`,
    IMPORT_QUESTION:`${HOST}/quantity/cover-rate/import-question?source=${source}&version=${version}`,
    IMPORT_KNOWLEDGE:`${HOST}/quantity/cover-rate/import-knowledge?source=${source}&version=${version}`,
    IMPORT_MULTIFORMITY:`${HOST}/quantity/cover-rate/import-multiformity?source=${source}&version=${version}`,
    GET_ASSIGN_ANSWER:`${HOST}/datauser/fix-data/detail`,
    EXPORT_ASSIGN_ANSWER:`${HOST}/datauser/fix-data/detail-statistics`,
    // v_1.5
    GET_DATA_USER: `${HOST}/datauser/fix-data/question`, // 布置作答数据
    GET_TRENDS_LINE: `${HOST}/datauser/fix-data/question-line`, // 布置作答数据变化趋势
    // v_1.6
    GET_CURRENT_LEARN: `${HOST}/datauser/knowledge-question/current-learn`, // 当前学习数据
    GET_SECTION_LIST: `${HOST}/datauser/knowledge-question/section-list`, // 章节列表
    GET_DISTRIBUTED_LIST: `${HOST}/datauser/knowledge-question/question`, // 题目分布数据
    GUIDE_DATA: `${HOST}/datauser/knowledge-question/download`, // 数据导出
    GET_EDITION_LIST_ALONE: `${HOST}/datauser/knowledge-question/edition-list`, // 课本列表
}
export default API;


// WEBPACK FOOTER //
// ./src/api/api.js